import { ChevronLeft, ChevronRight } from "lucide-react";

import { IconButton } from "@/components/ui/icon-button";
import { cn } from "@/lib/utils";

export interface TagInstanceNavigationButtonProps {
  direction: "previous" | "next";
  tagLabel: string;
  disabled: boolean;
  onClick: () => void;
  className?: string;
}

export function TagInstanceNavigationButton({
  direction,
  tagLabel,
  disabled,
  onClick,
  className,
}: TagInstanceNavigationButtonProps) {
  const isPrevious = direction === "previous";

  return (
    <IconButton
      label={`${isPrevious ? "Focus previous" : "Focus next"} instance for ${tagLabel}`}
      icon={isPrevious ? ChevronLeft : ChevronRight}
      size="xs"
      className={cn("text-muted-foreground hover:text-foreground", className)}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    />
  );
}
